import {useEffect, useRef} from "react";

import {setAmplitudeUserId, setAmplitudeUserProperties} from "@pg-mono/amplitude";
import {md5} from "@pg-mono/string-utils";

import {useGetUserProfileQuery} from "../../user/api/get_user_profile";

export const AmplitudeUserTracker = () => {
    const {data: userProfile} = useGetUserProfileQuery();
    const prevUserIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (userProfile?.email) {
            const hashedEmail = md5(userProfile.email.toLowerCase());
            const hashedPhone = userProfile.phone ? md5(userProfile.phone) : null;

            if (prevUserIdRef.current && prevUserIdRef.current !== hashedEmail) {
                setAmplitudeUserProperties({
                    previous_hashed_email: prevUserIdRef.current
                });
            }

            setAmplitudeUserId(hashedEmail);

            const userProperties: Record<string, string> = {
                email: hashedEmail
            };

            if (hashedPhone) {
                userProperties.phone_number = hashedPhone;
            }

            setAmplitudeUserProperties(userProperties);

            prevUserIdRef.current = hashedEmail;
        } else if (!userProfile) {
            setAmplitudeUserId(undefined);
            prevUserIdRef.current = null;
        }
    }, [userProfile]);

    return null;
};
import {useEffect, useRef} from "react";

import {setAmplitudeUserId, setAmplitudeUserProperties} from "@pg-mono/amplitude";
import {md5} from "@pg-mono/string-utils";

import {useGetUserProfileQuery} from "../../user/api/get_user_profile";

export const AmplitudeUserTracker = () => {
    const {data: userProfile} = useGetUserProfileQuery();
    const prevUserIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (userProfile?.email) {
            const hashedEmail = md5(userProfile.email.toLowerCase());
            const hashedPhone = userProfile.phone ? md5(userProfile.phone) : null;

            if (prevUserIdRef.current && prevUserIdRef.current !== hashedEmail) {
                setAmplitudeUserProperties({
                    previous_hashed_email: prevUserIdRef.current
                });
            }

            setAmplitudeUserId(hashedEmail);

            const userProperties: Record<string, string> = {
                email: hashedEmail
            };

            if (hashedPhone) {
                userProperties.phone_number = hashedPhone;
            }

            setAmplitudeUserProperties(userProperties);

            prevUserIdRef.current = hashedEmail;
        } else if (!userProfile) {
            setAmplitudeUserId(undefined);
            prevUserIdRef.current = null;
        }
    }, [userProfile]);

    return null;
};
